import { render, staticRenderFns } from "./WsHtmlText.vue?vue&type=template&id=8931a350"
import script from "./WsHtmlText.vue?vue&type=script&lang=js"
export * from "./WsHtmlText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports